<template>
  <!-- 欠薪预警：归属月次月 D 日=黄 / 次月底=橙 / 次次月底=红 -->
  <riskWarn domain="payroll" pageTitle="欠薪预警" themeColor="#FF5FA2"
    :subTabs="['欠薪']" :showAmount="true" />
</template>

<script>
import riskWarn from './riskWarn'
export default {
  name: 'payrollWarn',
  components: { riskWarn }
}
</script>
